export default "/imgs/jrn-2.png"